const overflowItems = document.querySelector('.anchor-bar__overflow-items');
const overflowDropdown = document.querySelector('.anchor-bar__dropdown');
const mobileMore = document.querySelector('.anchor-bar__label-mobile');
const anchorWrapper = document.querySelector('.anchor-bar__wrapper');
const windowWidth = window.innerWidth;

const moveOverflowItems = () => {
  // Move all items back to the main menu before recalculating
  while (overflowItems.firstChild) {
    wrapper.appendChild(overflowItems.firstChild);
  }

  // Re-select the items in the main menu
  const anchorBarItems = wrapper.querySelectorAll('.anchor-bar__item');

  if (windowWidth <= 599) {
    // For window widths 599px and below
    // Ensure all items are visible and hide the overflow menu
    overflowDropdown.classList.remove('active');
    overflowItems.classList.remove('open');
  } else {
    // For window widths above 599px
    let totalWidth = 0;
    const wrapperWidth = wrapper.clientWidth;

    // Loop through the items to calculate width and move to overflow if needed
    anchorBarItems.forEach((item) => {
      totalWidth += item.offsetWidth;

      if (totalWidth > wrapperWidth) {
        // Move the item to the overflow dropdown
        overflowItems.appendChild(item);
      }
    });

    // Toggle the active class based on whether items exist in the overflow
    if (overflowItems.children.length > 0) {
      overflowDropdown.classList.add('active');
    } else {
      overflowDropdown.classList.remove('active');
    }
  }
};

// Build the <ul> only when there are anchors to put in it
const generateAnchorBarItems = () => {
  if (!anchorWrapper) return null;

  const anchorElements = document.querySelectorAll('[data-anchor-id][data-anchor-label]');
  if (anchorElements.length === 0) return null;

  const list = document.createElement('ul');
  list.classList.add('anchor-bar__items');

  anchorElements.forEach((element) => {
    const anchorId = element.getAttribute('data-anchor-id');
    const anchorLabel = element.getAttribute('data-anchor-label');

    if (anchorId && anchorLabel) {
      const listItem = document.createElement('li');
      listItem.classList.add('anchor-bar__item');

      const link = document.createElement('a');
      link.href = `#${anchorId}`;
      link.textContent = anchorLabel;
      link.classList.add('anchor-bar__link');

      listItem.appendChild(link);
      list.appendChild(listItem);
    }
  });

  if (!list.hasChildNodes()) return null;

  if (overflowDropdown) {
    anchorWrapper.insertBefore(list, overflowDropdown);
  } else {
    anchorWrapper.appendChild(list);
  }

  return list;
};

const wrapper = generateAnchorBarItems();

const mobileStack = () => {
  mobileMore.addEventListener('click', (event) => {
    event.preventDefault();
    anchorWrapper.classList.toggle('open');
  });
};

if (wrapper) {
  moveOverflowItems();
  mobileStack();
  window.addEventListener('resize', moveOverflowItems);

  // Toggle dropdown on click
  overflowDropdown.addEventListener('click', (event) => {
    overflowItems.classList.toggle('open');
  });

  // Close dropdown if clicked outside
  document.addEventListener('click', (event) => {
    if (!overflowDropdown.contains(event.target) && overflowItems.classList.contains('open')) {
      overflowItems.classList.remove('open');
    }
    if (!mobileMore.contains(event.target) && anchorWrapper.classList.contains('open')) {
      anchorWrapper.classList.remove('open');
    }
  });

  // Close dropdown if 'Escape' key is pressed
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && overflowItems.classList.contains('open')) {
      overflowItems.classList.remove('open');
    }
  });

  // Close dropdown if focus is lost from the dropdown or its children
  overflowItems.addEventListener('focusout', (event) => {
    // Check if the newly focused element is outside the dropdown
    if (!overflowDropdown.contains(event.relatedTarget)) {
      overflowItems.classList.remove('open');
    }
  });
}

// Anchor bar sticky behavior on pages
document.addEventListener('DOMContentLoaded', () => {
  const anchorBar = document.querySelector('.anchor-bar');
  const getElementTop = (element) => {
    if (!element) {
      throw new Error('Element is not provided or invalid.');
    }
    const rect = element.getBoundingClientRect();
    return rect.top + window.scrollY;
  };

  const getElementBottom = (element) => {
    if (!element) {
      throw new Error('Element is not provided or invalid.');
    }
    const rect = element.getBoundingClientRect();
    return rect.bottom + window.scrollY;
  };

  // Find the last section with an ID
  const firstSectionWithId = document.querySelector('.section[id]');
  const sectionsWithId = [...document.querySelectorAll('.section[id]')];
  // eslint-disable-next-line max-len
  const lastSectionWithId = sectionsWithId.length > 0 ? sectionsWithId[sectionsWithId.length - 1] : null;

  // Function to update offsets dynamically
  const getOffsets = () => ({
    // firstSectionTop: anchorBar.offsetTop,
    firstSectionTop: firstSectionWithId ? getElementTop(firstSectionWithId) : Infinity,
    lastSectionBottom: lastSectionWithId ? getElementBottom(lastSectionWithId) : Infinity,
  });
  let offsets = getOffsets();

  // Scroll logic for sticky behavior
  const handleStickyBehavior = () => {
    const scrollTop = window.scrollY;

    if (scrollTop > offsets.firstSectionTop) {
      if (scrollTop < offsets.lastSectionBottom) {
        anchorBar.classList.add('is-sticky');
        anchorBar.classList.remove('is-hidden');
      } else {
        anchorBar.classList.remove('is-sticky');
        anchorBar.classList.add('is-hidden');
      }
    } else {
      anchorBar.classList.remove('is-sticky');
      anchorBar.classList.remove('is-hidden');
    }
  };

  // Select all anchor links and sections
  const sections = document.querySelectorAll('.section[id]');

  // Function to update active nav link based on scroll position
  const updateActiveNav = () => {
    const scrollPos = window.scrollY;
    const offset = 75; // 75px offset from the top of the viewport

    sections.forEach((section) => {
      // Get the top and bottom positions of the section relative to the document
      const sectionTop = section.offsetTop;
      const sectionBottom = sectionTop + section.offsetHeight;

      // Find the corresponding nav link for this section
      const correspondingLink = document.querySelector(`a[href="#${section.id}"]`);

      // If the section's top is at (or above) the viewport top + offset
      // and its bottom is still below the viewport top + offset,
      // then mark this link as active.
      if (scrollPos + offset >= sectionTop && scrollPos + offset < sectionBottom) {
        if(correspondingLink) {
          correspondingLink.classList.add('is-active');
        }
      } else {
        if(correspondingLink) {
          correspondingLink.classList.remove('is-active');
        } 
      }
    });
  };

  if (anchorBar) {
    // Throttle scroll event using requestAnimationFrame
    let ticking = false;

    // Combined onScroll function to handle both sticky behavior
    // and updating the active navigation link.
    const onScroll = () => {
      handleStickyBehavior();
      updateActiveNav();
    };

    // Attach a single scroll event listener that uses requestAnimationFrame to throttle execution.
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          onScroll();
          ticking = false;
        });
        ticking = true;
      }
    });

    // Update offsets on window resize
    window.addEventListener('resize', () => {
      offsets = getOffsets();
      handleStickyBehavior();
    });

    // Once the DOM is fully loaded, update the active navigation
    // link based on the current scroll position.
    document.addEventListener('DOMContentLoaded', updateActiveNav);
  }
});
